module.exports = __webpack_public_path__ + "img/file-zip.edc0548f.svg";